export default __webpack_public_path__ + "static/media/service3.e9a6ec4b.jpeg";